import React from "react";
// Stylesheet
import "./Backdrop.scss";
//Images
const Backdrop = ({ children }) => {
  return <div className="backdrop">{children}</div>;
};
export default Backdrop;
